const DEFAULT_FORMULA_SUGGESTIONS = ['SUM', 'IF', 'MIN', 'MAX', 'COUNT', 'AVERAGE'];

export const getMatchingFormulas = (query: string, allFormulas: string[]) => {
    const normalisedQuery = query.toUpperCase();
    if (!normalisedQuery) return DEFAULT_FORMULA_SUGGESTIONS;

    return allFormulas.filter((formula) => formula.startsWith(normalisedQuery));
};
